<script lang="ts">
  // "vinallowlist" is a normal grapi-discovered table (chart/values.yaml update-db
  // migration), not a file - per Patrick, so it scales to the millions of VINs Mercedes
  // will provide. This is the standard generic CRUD grid, same as parts.svelte /
  // dealerships.svelte.
  import('App/Vinallowlist').then((m) => {
    let module = m.default;

    new module({
      target: document.getElementById('vin-allowlist'),
      layout: 'auto',
    });
  });
</script>

<div id="vin-allowlist" />
